import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SchoolIcon from '@mui/icons-material/School';
import TopicIcon from '@mui/icons-material/Topic';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import {
    Box,
    Button,
    Grid,
    Typography
} from "@mui/material";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopicPulseMocups from '../MarketingSiteComponents/TopicPulseMocups';
import getAllSubscriptionsService from '../services/OwnTestCreationServices/getAllSubscriptionsService';

// import { Award, GraduationCap, MapPin, TrendingUp } from "lucide-react";


const TopicPulse = ({ isLoggedIn, handleShowSubcription }) => {
    const navigate = useNavigate();
    // console.log(subscription, '-subsinTP')
    // const [price] = useState(subscription?.price ?? 0);
    const [showCheckout, setShowCheckout] = useState(false);
    const [loading, setLoading] = useState(false);
    // const series = {
    //     subscriptionTypeId: subscription?.subscriptionTypeId,
    //     courseId: subscription?.subscriptionTypeId ?? 0,
    //     price: price ?? 0,
    // };

    const onNextHandle = async () => {
        setLoading(true)
        const subscription = await getAllSubscriptionsService();
        console.log(subscription, '-subs respintp')
        const series = {
            subscriptionTypeId: subscription[0]?.subscriptionTypeId,
            courseId: subscription[0]?.subscriptionTypeId ?? 0,
            price: subscription[0]?.price ?? 0,
        };
        const ResourceTypeId = 4;
        if (isLoggedIn) {
            setShowCheckout(true);
        } else {
            handleShowSubcription('#college-predictor')
            navigate("/medineer/SignUp", { state: { series, ResourceTypeId } });
        }
        setLoading(false)
    };
    return (
        <Box
            id="topicPulse"
            sx={{
                position: "relative",
                py: { xs: 8, md: 12 },
                bgcolor: "white",
                overflow: "hidden",
                fontSize: '1.2rem'
            }}
        >
            {/* Decorative background circles */}
            <Box
                sx={{
                    position: "absolute",
                    top: -100,
                    left: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "primary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    bottom: -100,
                    right: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "secondary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />

            <Box sx={{ position: "relative", zIndex: 2, px: 2, maxWidth: 1200, mx: "auto" }}>
                <Grid container spacing={6} alignItems="center">


                    {/* LEFT SECTION */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" mb={4} sx={{ fontSize: '2rem', lineHeight: '2.8rem', color: '#242e42', textAlign: 'left', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}>
                            Create your own <Box component="span" sx={{ color: "primary.main" }}> topic pulse.</Box>
                        </Typography>
                        <TopicPulseMocups />
                        <Button
                            variant="contained"
                            size="large"
                            sx={{
                                mt: 2,
                                borderRadius: 3,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: '1.4rem',
                                color: '#fff',
                                background: 'linear-gradient(135deg, hsl(45 100% 60%), hsl(18 90% 58%))',
                                float: 'left'
                            }}
                            onClick={onNextHandle}
                        // onClick={() => {
                        //     document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                        // }}
                        >
                            {/* Get Free 3 Topicwise Tests 🎉 */}
                            Get Started
                        </Button>
                    </Grid>
                    {/* RIGHT SECTION */}
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.5, mb: 2, bgcolor: "secondary.light", px: 2, py: 1, borderRadius: 5, background: '#ECEED1' }}>
                            <EmojiEventsIcon size={20} color="#1976d2" />
                            <Typography fontWeight={600} color="primary.main" sx={{ fontSize: '1.4rem' }}>
                                Topic Pulse
                            </Typography>
                        </Box>

                        <Typography
                            variant="h3"
                            sx={{
                                fontSize: '4.3rem',
                                textAlign: 'left',
                                fontWeight: 700,
                                mb: 2,
                                lineHeight: 1.2,
                                color: "#242e42",
                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                            }}
                        >
                            Start Your{" "}
                            <Box component="span" sx={{ color: "primary.main" }}>
                                Success Path
                            </Box>{" "}!
                        </Typography>

                        <Typography variant="h6" mb={4} sx={{ fontSize: '2rem', lineHeight: '2.8rem', color: '#6c7993', textAlign: 'left', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}>
                            Take charge of your <Box component="span" sx={{ color: "primary.main" }}>success journey</Box> with on-demand tests aligned to your preparation.
                        </Typography>

                        {/* Feature list */}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                            {[
                                {
                                    icon: <DashboardCustomizeIcon sx={{ color: "#F4743D", fontSize: '2rem' }} />,
                                    title: "Build your own plan",
                                    desc: "Pick the right test immediately after mastering a topic.",
                                    bgcolor: '#f46d341a'
                                },
                                {
                                    icon: <TrendingUpIcon sx={{ color: '#13ACCA', fontSize: '2rem' }} />,
                                    title: "Performance reviews",
                                    desc: "Get instant reviews with detailed solutions and clear insights for every question.",
                                    bgcolor: '#05a7c71a'
                                },
                                {
                                    icon: <TopicIcon sx={{ color: "#FFCD35", fontSize: '2rem' }} />,
                                    title: "Start today — be confident",
                                    desc: "Focused practice and stay ahead of the competition.",
                                    bgcolor: '#ffcc331a'
                                },
                            ].map((item, i) => (
                                <Box key={i} sx={{ display: "flex", gap: 2, textAlign: 'left' }}>
                                    <Box
                                        sx={{
                                            p: 1,
                                            borderRadius: "50%",
                                            bgcolor: "grey.100",
                                            height: 36,
                                            width: 36,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={600} sx={{ fontSize: '1.6rem', lineHeight: '2.4rem', color: '#242e42', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}>{item.title}</Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '1.4rem', lineHeight: '2rem', color: '#6c7993', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' }}>
                                            {item.desc}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        <Button
                            variant="contained"
                            size="large"
                            endIcon={<SchoolIcon />}
                            sx={{
                                mt: 4,
                                borderRadius: 3,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: '1.4rem',
                                background: '#0B3054',
                                color: '#fff',
                                float: 'left'
                            }}
                            onClick={onNextHandle}
                        >{
                                loading ? 'Loading...' :
                                    'Get Topic Pulse @ ₹390'
                            }
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default TopicPulse;
